import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import websocketService from '../services/websocketService';

interface WebSocketProviderProps {
  children: React.ReactNode;
}

export const WebSocketProvider: React.FC<WebSocketProviderProps> = ({ children }) => {
  const { user } = useAuth();

  useEffect(() => {
    if (user?.id) {
      // Connect to WebSocket server
      websocketService.connect(user.id);

      // Set up global notification handlers
      websocketService.on('newPost', (data: any) => {
        console.log('🔔 Global new post notification:', data);
        
        // Show browser notification if permission is granted
        if (window.Notification && Notification.permission === 'granted') {
          new window.Notification('New Content!', {
            body: data.message,
            icon: '/favicon.ico',
            tag: 'new-post-' + data.postId
          });
        }
      });

      websocketService.on('newNotification', (data: any) => {
        console.log('🔔 Global new notification:', data);
      });

      // Request notification permission on first load
      if (window.Notification && Notification.permission === 'default') {
        Notification.requestPermission().then(permission => {
          console.log('Notification permission:', permission);
        });
      }

      return () => {
        websocketService.disconnect();
      };
    }
  }, [user?.id]);

  return <>{children}</>;
};